import styled from '@emotion/styled';
import { animated } from '@react-spring/web';
export const SpringCarouselWrapper = styled.div `
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
export const AnimatedSpringCarouselWrapper = styled(animated.div) `
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: relative;
  touch-action: pan-y
`;
export const SpringCarouselItemWrapper = styled.div `
  display: flex;
  flex: 1 0 calc(100% / ${({ itemsPerSlide }) => itemsPerSlide});
  position: relative;
  max-width: 100%;

  > * {
    flex: 1;
  }
`;
export const SlidesContainer = styled.div `
  background: linear-gradient(-33deg, #fff 50%, #e2ebff 0);
  background-image: linear-gradient(-33deg, #fff 50%, #e2ebff 0px);
  cursor: ${({ isDragging }) => (isDragging ? 'grab' : 'pointer')};

  /* Prevent image ghosting */
  img {
    pointer-events: none;
    user-select: none;
  }
`;
export const SliderWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
`;
export const TermsAndConditions = styled.a `
  background: rgba(105, 105, 105, 0.5);
  position: absolute;
  color: ${({ theme }) => theme.colors.interactions.CTA.text.default};
  border-radius: ${({ theme }) => theme.radii[2]};
  font-size: ${({ theme }) => theme.fontSizes[1]};
  font-weight: ${({ theme }) => theme.fontWeights.body};
  padding: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[5]};
  right: ${({ theme }) => theme.space[5]};
  top: ${({ theme }) => theme.space[5]};
  transition: background ${({ theme }) => theme.animations.timeDefault} ${({ theme }) => theme.animations.out};

  &:hover {
    background: rgba(105, 105, 105, 0.7);
    color: ${({ theme }) => theme.colors.interactions.CTA.text.hover};
  }
`;
